import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import numeral from 'numeral';

import DataTable from '../../../components/DataTable';
import Modal from '../../../components/Modal';
import Page from '../../../components/Page';

import { TabHolder, Tab } from '../../../components/Tabs';
import BlankState from '../../../components/BlankState';

import GoodsRatesForm from './GoodsRatesForm';

import { fetchPremiumRates } from '../../../actions/dashboard';
import { listGoodsSections } from '../../../actions/policy';
import { listPartners } from '../../../actions/brokers';
import { listCovers } from '../../../actions/openCovers';

class GoodsRates extends Component{

    constructor(props){
        super(props);
        const insurer = JSON.parse(sessionStorage.user).insurer;
        
        this.state = {
            insurer,
            filter: {
                insurer
            },
            activeRate: {}
        };
    }

    componentDidMount(){
        const { listGoodsSections, listCovers, listPartners } = this.props;

        this.loadPremiumRates();
        listGoodsSections();
        listCovers();
        listPartners();
    }

    loadPremiumRates(){
        this.props.fetchPremiumRates(this.state.filter);
    }

    editRates = (rate) => {
        this.setState({ activeRate: rate });
    }

    resetRatesForm = () => {
        this.setState({
            activeRate: {}
        })
    }

    onChangeFilter = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        
        this.setState({
            filter: {
                insurer: this.state.insurer,
                [name]: value
            }
        }, ()=>{
            this.loadPremiumRates();
        });
    }

    resetFilter = (e) => {
        this.setState({
            filter: {
                insurer: this.state.insurer
            }
        }, ()=>{
            this.loadPremiumRates();
        });
    }

    render(){
        const menuItems = [
			{ id: "goods-rates", name: "Premium Rates on Goods", active: true },
            { id: "custom-rates", name: "Setup Custom Rates" }
        ]
        
        const { filter, activeRate } = this.state;
        const { dashboard, brokers, policy, covers } = this.props;

    	return(
            <Page isAdminPage={ true } pageTitle="Goods Rates">
                <TabHolder menuItems={ menuItems }>
					
                    <Tab menuId={ menuItems[0].id } isActive={ true }>
                        
                        <div className="row">
                            <div className="col-sm-3">
                                <select
                                    name="intermediary_partnership"
                                    className="form-control"
                                    onChange={ this.onChangeFilter }
                                    value={ filter.intermediary_partnership || '' }>

                                    <option value="">- Select Broker Partnership -</option>
                                    {
                                        brokers.partners.map((partner, index)=>{
                                            return(
                                                <option key={ index } value={ partner.id }>
                                                    { partner.intermediary_name }
                                                </option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                            <div className="col-sm-3">
                                <select 
                                    name="corporate_client" 
                                    className="form-control"
                                    onChange={ this.onChangeFilter }
                                    value={ filter.corporate_client || '' }>

                                    <option value="">- Select Open Cover Client -</option>
                                    {
                                        covers.openCovers.map((cover, index)=>{
                                            return(
                                                <option key={ index } value={ cover.company }>
                                                { cover.company_name }
                                                </option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                            <div className="col-sm-3">
                                <select 
                                    name="section" 
                                    className="form-control"
                                    onChange={ this.onChangeFilter }
                                    value={ filter.section || '' }>

                                    <option value="">- Select Section -</option>
                                    {
                                        policy.goodsSections.map((section, index)=>{
                                            return(
                                                <option key={ index } value={ section.id }>
                                                { section.code }
                                                </option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                            <div className="col-sm-3">
                                <button 
                                    className="btn btn-default"
                                    onClick={ this.resetFilter }>
                                    <i className="icon ion-loop"></i> Reset
                                </button>
                            </div>
                            <hr />
                        </div>

                        <div className="clearfix table-legend">
                            KEY: &nbsp;
                            <span className="label label-success">Containerised Value</span> &nbsp;
                            <span className="label label-warning">Non-containerised Value</span> &nbsp;
                            <span className="label label-info">Value</span>
                        </div>

                    {
                        dashboard.premiumRates.length > 0 ?
                        
                        <DataTable 
                            tableId="premium-rates-table"
                            columnTitles={ ["Good", "Sea ICC-A", "Sea ICC-B", "Sea ICC-C", "Air ICC-A", "Road", "Rail", "Insurer", "Intermediary", "Action"] }
                            sortOrder={ [0, 'asc'] }>
                            
                        {
                            dashboard.premiumRates.map((rates, index) => {
                                const { section_name, icc_a, icc_b, icc_c, road_value, rail_value, insurer_name, intermediary_name } = rates;
                                
                                return (
                                    <tr key={ index }>
                                        <td style={{ width: '35%' }}>{ section_name }</td>
                                        <td>
                                            <div className="label label-success">
                                                { numeral(icc_a.sea_containerised_value).value('0,0') || '-' }
                                            </div>
                                            <br/>
                                            <div className="label label-warning">
                                                { numeral(icc_a.sea_non_containerised_value).value('0,0') || '-' }
                                            </div>
                                        </td>
                                        <td>
                                        <div className="label label-success">
                                                { numeral(icc_b.sea_containerised_value).value('0,0') || '-' }
                                            </div>
                                            <br/>
                                            <div className="label label-warning">
                                                { numeral(icc_b.sea_non_containerised_value).value('0,0') || '-' }
                                            </div>
                                        </td>
                                        <td>
                                            <div className="label label-success">
                                                { numeral(icc_c.sea_containerised_value).value('0,0') || '-' }
                                            </div>
                                            <br/>
                                            <div className="label label-warning">
                                                { numeral(icc_c.sea_non_containerised_value).value('0,0') || '-' }
                                            </div>
                                        </td>
                                        <td>
                                            <span className="label label-info">
                                                { numeral(icc_a.air_value).value('0,0') }
                                            </span>
                                        </td>
                                        <td>{ numeral(road_value).value('0,0') }</td>
                                        <td>{ numeral(rail_value).value('0,0') }</td>
                                        <td>{ insurer_name }</td>
                                        <td>{ intermediary_name || '-' }</td>
                                        <td>
                                            <button
                                                data-toggle="modal"
                                                data-target=".goods-rates-modal"
                                                className="btn btn-sm btn-warning"
                                                onClick={ ()=>{ this.editRates(rates) } } >
                                                
                                                <i className="icon ion-edit"></i> Edit
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        </DataTable>
                    :
                        <BlankState
                            data={ dashboard.premiumRates }
                            dataName="Premium Rates"
                            isDataLoading={ dashboard.premiumRatesLoading } />
                    }

                        <Modal 
                            title="Goods Rates"
                            className="modal-lg goods-rates-modal"
                            closable={ true }
                            onCloseFn={ this.resetRatesForm }>

                            <GoodsRatesForm activeRate={ activeRate } />
                        </Modal>
                    </Tab>
                    
                    <Tab menuId={ menuItems[1].id }>
                        <GoodsRatesForm />
                    </Tab>
                </TabHolder>
			</Page>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    dashboard: state.dashboard,
    brokers: state.brokers,
    covers: state.covers,
    policy: state.policy,
    rates: state.rates
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ fetchPremiumRates, listGoodsSections, listCovers, listPartners }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(GoodsRates);


// WEBPACK FOOTER //
// ./src/pages/dashboard/rates/GoodsRates.jsx